import type { ComponentProps, ReactNode } from "react";
import { Archive, MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoveToDropdown, useMoveTo } from "@/components/MoveToDropdown";

type MovableCompany = ComponentProps<typeof MoveToDropdown>["company"];

/** The header's "..." menu on a company page: the page's own items, Move to, then Archive. */
export function CompanyMoreMenu({ company, onArchive, children }: { company: MovableCompany; onArchive: () => void; children?: ReactNode }) {
  const { items: moveItems, dialogs: moveDialogs } = useMoveTo(company);
  return (
    <>
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 w-8 min-h-0 p-0" aria-label="More actions">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {children}
        {moveItems}
        <DropdownMenuSeparator />
        <DropdownMenuItem className="text-destructive focus:text-destructive" onSelect={(e) => { e.preventDefault(); onArchive(); }}>
          <Archive className="mr-2 h-4 w-4" />Archive
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    {/* Outside the menu: the confirm's state must survive the menu closing. */}
    {moveDialogs}
    </>
  );
}
